import QueryString from 'query-string'
import { Component } from 'react'
import R from './ramda'
import U from './Utils'

class AbstractApp extends Component {
  constructor(props) {
    super(props)

    this.state = {
      // Filtri attivi
      // Per i filtri a selezione multipla vengono salvate più voci,
      // una per ogni livello, con chiave "${filter_name}_${level}".
      // Ad esempio per un filtro "prof" si potrebbero avere le voci:
      //  - prof_1: [18,19],
      //  - prof_2: [34],
      filters: {},

      // Descrizione dei filtri attivi.
      // Indipendentemente dal tipo di filtro viene salvata un'unica voce,
      // con chiave = nome filtro e valore = array di descrizioni.
      // Es:
      //  - prof: ['Impiegati', 'Operai specializzati', 'Manovali ediili']
      // Sono escluse le date (from/to).
      filter_descr: {},

      // {loading: true}, {error: 'msg'} oppure i dati ricevuti
      data: { loading: true },
    }
  }

  componentDidMount() {
    window.onpopstate = (ev) => {
      this.setState(ev.state, () => this.loadData())
    }

    window.onhashchange = () => {
      this.applyHash(window.location.hash)
    }

    if (window.location.hash) {
      this.applyHash(window.location.hash)
    } else {
      this.loadData()
    }
  }

  getHash() {
    const { filters, filter_descr } = this.state
    return btoa(JSON.stringify({ filters, filter_descr }))
  }

  applyHash(hash) {
    if (!hash) return
    const { filters, filter_descr } = JSON.parse(atob(hash.substring(1)))
    this.setState(
      {
        filters,
        filter_descr,
        data: { loading: true },
      },
      () => this.loadData(),
    )
  }

  // Ottiene l'URL di download dei dati
  getDataUrl() {
    // Crea la query-string omettendo i filtri vuoti/null/false,
    // con le chiavi e i valori ordinati, per sfruttare la cache server-side
    let query = QueryString.stringify(
      R.pipe(
        R.filter(R.identity),
        R.map((val) => (R.is(Array, val) ? R.sortBy(R.identity, val) : val)),
        R.toPairs(),
        R.sortBy(R.prop(0)),
        R.fromPairs(),
      )(this.state.filters),
    )
    return `${this.API_URL}/data?${query}`
  }

  makeDictUrl(name) {
    return `${this.API_URL}/dict/${name}`
  }

  applyFilterUpdater(filterUpdater, filterDescrUpdater) {
    this.setState(
      (prevState) => ({
        filters: filterUpdater(prevState.filters),
        filter_descr: filterDescrUpdater(prevState.filter_descr),
        data: { loading: true },
      }),
      () => {
        window.history.pushState(this.state, '', '#' + this.getHash())
        this.loadData()
      },
    )
  }

  loadData() {
    U.loadJsonData(this.getDataUrl(), (data) => this.setState({ data }))
  }

  makeDrillDownHandler(name) {
    const { data } = this.state
    const lev = data[`${name}_lev`]
    const has_drilldown = data[`${name}_drilldown`]
    if (!has_drilldown) return null
    return (id, descr) => {
      this.applyFilterUpdater(
        R.pipe(
          R.pickBy((v, k) => !k.match(`^${name}_`)),
          U.set(`${name}_${lev}`, [id]),
        ),
        U.set(name, [descr]),
      )
    }
  }

  getSeries() {
    let { filters } = this.state
    if (filters.gen) {
      return [
        { suf: '_m', name: 'Uomini' },
        { suf: '_f', name: 'Donne' },
      ]
    } else if (filters.ita) {
      return [
        { suf: '_i', name: 'Italiani' },
        { suf: '_s', name: 'Stranieri' },
      ]
    } else {
      return [{ suf: '', name: '' }]
    }
  }
}

export default AbstractApp



// WEBPACK FOOTER //
// ./src/AbstractApp.js